export class AwsSourceAccountAttributesInput {
    'roleArn';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "roleArn",
            "baseName": "roleArn",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AwsSourceAccountAttributesInput.attributeTypeMap;
    }
    constructor() {
    }
}
